import { CircularProgress } from '@medely/web-components';
import React, { useEffect } from 'react';
import { StringParam, useQueryParams } from 'use-query-params';
import useSignUp from '../SignUp/useSignUp';
import { decryptSignUpFormValues } from './utils';

const Create = () => {
  const signUp = useSignUp();
  const [{ h }] = useQueryParams({
    h: StringParam,
  });

  useEffect(() => {
    const formValues = decryptSignUpFormValues(h);
    signUp(formValues);
  }, []);

  return <CircularProgress />;
};

export default Create;
